import { createFileRoute } from "@tanstack/react-router";

import { StartIndexPage } from "@pages/start/index";

export const Route = createFileRoute("/start")({
  component: StartIndexPage,
});
